<template>
  <div :class="$style.bar">
    <div :class="$style.left">
      <slot />
      <slot name="left" />
    </div>
    <div
      v-if="$slots.right"
      :class="$style.right"
    >
      <slot name="right" />
    </div>
  </div>
</template>

<style module lang="scss">
.bar, .left, .right {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.bar {
  justify-content: space-between;
  width: 100%;
  &:not(:first-child) {
    margin-top: 1rem;
  }
}
.left {
  justify-content: flex-start;
}
.right {
  justify-content: flex-end;
}
</style>
